import React from 'react';

// Única definición del fondo del shell, el contenido y ambos cargadores.
export const APP_SURFACE = 'bg-secondary-50 dark:bg-secondary-900';

export default function PageLoader({ fullPage = false }) {
    return (
        <div role="status" className={`${APP_SURFACE} flex items-center justify-center ${fullPage ? 'min-h-screen' : 'min-h-40 p-8'}`}>
            <div className="flex items-center gap-3 text-secondary-600 dark:text-secondary-300">
                <span aria-hidden="true" className="h-5 w-5 animate-spin motion-reduce:animate-none rounded-full border-2 border-secondary-300 border-t-purple-600" />
                <span className="text-sm">Cargando...</span>
            </div>
        </div>
    );
}
